import { render, staticRenderFns } from "./ManageCategoryDialog.vue?vue&type=template&id=3cfa06b4&scoped=true&"
import script from "./ManageCategoryDialog.vue?vue&type=script&lang=js&"
export * from "./ManageCategoryDialog.vue?vue&type=script&lang=js&"
import style0 from "./ManageCategoryDialog.vue?vue&type=style&index=0&id=3cfa06b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa06b4",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VTextField})
